import { ordersApi } from "./ordersApi";

let dispatch = null;

export const attachOrdersCache = (store) => {
  dispatch = store.dispatch;
};

export const invalidateOrders = () => {
  dispatch?.(ordersApi.util.invalidateTags(["Order"]));
};
